/**
 * Store pour la gestion des pays
 */

import { ref, computed } from 'vue';
import { defineStore } from 'pinia';
import axios from '@js/tools/axios';

export const useCountryStore = defineStore('country', (() => {

    // State des pays chargés
    const countries = ref([]);

    /**
     * Retourne la liste des pays
     * @return array
     */
    const getCountries = computed(() => countries.value);

    /**
     * Retourne le pays dont le code ISO est en paramètre
     * @return Object|null
     */
    const getCountryByCode = computed(() => {
        return ((code) => {
            const countryFound = getCountries.value.filter((country) => country.code === code).at(0);
            return (countryFound ?? null);
        });
    });

    /**
     * Chargement de la liste des pays
     * @return Promise
     */
    const loadCountryList = (() => {

        if(countries.value.length > 0) {
            return Promise.resolve();
        }

        const path = '/api/countries';

        return axios.get(path).then((response) => {
            if(response && response.data && response.data.success && response.data.countries) {
                countries.value = response.data.countries;
                return Promise.resolve();
            }
            return Promise.reject();
        });

    });

    return {
        getCountries,
        getCountryByCode,
        loadCountryList
    };
}));
